import React from 'react';
import styled from 'styled-components';
import {TypographyChildrenProps} from './Typography';
import {getLocale} from '@epic-core/common';
import {CombinedTextColorProps, useCombinedTextColor} from 'epic-ue-theme';

interface TypographyParagraphProps {
    big?: boolean;
    giant?: boolean;
    caption?: boolean;
    tinyCaption?: boolean;
}

const Paragraph = styled.div<TypographyParagraphProps & CombinedTextColorProps>`
    font-family: ${(p) => p.theme.fonts.brutal.regular};
    font-weight: 400;
    letter-spacing: 0;
    font-size: 16px;
    line-height: 30px;
    margin: 0;

    &.paragraph {
        color: ${(p) => useCombinedTextColor(p.color)};
    }

    b,
    strong {
        font-family: ${(p) => p.theme.fonts.brutal.bold};
        font-weight: 500;
    }

    &.caption {
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0.2px;
    }

    &.tinyCaption {
        font-size: 12px;
        line-height: 22px;
        letter-spacing: 0.2px;
    }

    &.big {
        font-size: 20px;
        line-height: 36px;
        letter-spacing: 0;

        ${(p) => p.theme.breakpoints.down('md')} {
            font-size: 18px;
            line-height: 32px;
        }
    }

    &.loc-ko {
        word-wrap: break-word;
        word-break: keep-all;
    }
`;

export const TypographyParagraph = ({
    children,
    big,
    giant,
    caption,
    tinyCaption,
    color,
    as,
    className = ''
}: TypographyChildrenProps & TypographyParagraphProps): JSX.Element => {
    return (
        <Paragraph
            className={`paragraph ${big ? 'big' : ''} ${caption ? 'caption' : ''} ${giant ? 'giant' : ''} ${
                tinyCaption ? 'tinyCaption' : ''
            } ${className} loc-${getLocale()}`}
            big={big}
            caption={caption}
            color={color}
            as={as}>
            {children}
        </Paragraph>
    );
};
